import configuration from './configuration';
import BLSData from './BLSData';

export default [...configuration, ...BLSData];
